<template>
	<!--   <div v-show="!listLoading && total " class="pagination">-->
	<div class="pagination">
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					   :current-page.sync="listQuery.page.pageNo"
					   prev-text="上一页" next-text="下一页"
					   layout="total, prev, pager, next, jumper" :total="total">
			<!--:page-sizes="pageSizes || appConfig.PAGE_SIZE" :page-size="pagination.pageSize"-->
		</el-pagination>
	</div>
</template>
<script type="text/ecmascript-6">
	import {mapGetters} from 'vuex'

	export default {
		name: "pagination",
		methods: {
			getList() {
				this.$emit('getList');
			},
			handleSizeChange(val) {
				this.$store.dispatch('setPageSize', val);
				this.appConfig.DEFAULT_PAGE_SIZE = val
				this.listQuery.page.pageSize = val
				this.getList()
			},
			handleCurrentChange(val) {
				this.listQuery.page.pageNo = val;
				this.getList();
			}
		},
		computed: {
			...mapGetters([
				'pagination',
			])
		},
		props: ['listLoading', 'listQuery', 'total', 'pageSizes']
	}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/pagination.vue